import React from 'react';
import ReactDOM from 'react-dom';
import AppHeader from './components/Header';
import Footer from './components/Footer';

const headerNode = document.getElementById('cccisd-header');
if (headerNode) {
    ReactDOM.render(<AppHeader />, headerNode);
}

const footerNode = document.getElementById('cccisd-footer');
if (footerNode) {
    ReactDOM.render(<Footer />, footerNode);
}
